<!-- eslint-disable -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="30"
       height="30"
       viewBox="0 0 30 30"
       fill="none">
    <title>Suche schließen</title>
    <path d="M22.1992 9.39941L16.5986 14.999L22.1992 20.5996L20.5986 22.2002L14.998 16.5996L9.39844 22.2002L7.79883 20.5996L13.3984 14.999L7.79883 9.39941L9.39941 7.7998L14.999 13.3994L20.5986 7.7998L22.1992 9.39941Z" fill="currentColor"/>
  </svg>
</template>
<!-- eslint-enable -->

<script>
export default {
  name: 'SearchCloseIcon',
};
</script>
